import React from 'react'
import parse from 'html-react-parser'


const EmbeddableContent = ({ markup }) => {
  if (!markup) {
    return null
  }
  
  return (
    <div>{parse(markup)}</div>
  )
}

export default EmbeddableContent